import autobind from 'class-autobind';

import Request from './Request';

export default class RequestBatch {
  constructor() {
    autobind(this);
    this.createdTime = Date.now();
    this.requests = [];
    this.completed = false;
  }

  addRequest(request) {
    const r = request instanceof Request ? request : new Request(request);
    this.requests.push(r);
    return r;
  }

  async start() {
    const promises = this.requests.map(request => request.start());
    await Promise.all(promises);
    this.completed = true;
    this.onComplete(this);
  }
}
